<app-page-header title="Választás - HVB határozatok"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <ul class="my-3 text-center">
    <li
      *ngFor="let doc of documents"
      (click)="download(doc.name, null, doc.path)"
    >
      <i class="fas mr-3 fa-file-pdf"></i>{{ doc.name }}
    </li>
  </ul>
</div>
